import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.updateButtonState()
  }

  updateButtonState() {
    const catalogueSelect = this.element.querySelector('select[name="catalogue_id"]')
    const weightInput = this.element.querySelector('input[name="weight"]')
    
    if (catalogueSelect && weightInput) {
      const catalogueSelected = catalogueSelect.value !== ''
      const weightValid = weightInput.value >= 1 && weightInput.value <= 10
      
      if (this.hasButtonTarget) {
        this.buttonTarget.disabled = !catalogueSelected || !weightValid
        this.buttonTarget.classList.toggle('opacity-50', !catalogueSelected || !weightValid)
        this.buttonTarget.classList.toggle('cursor-not-allowed', !catalogueSelected || !weightValid)
      }
    }
  }

  catalogueChanged() {
    this.updateButtonState()
  }

  weightChanged() {
    this.updateButtonState()
  }
} 